import { autoinject, bindingMode } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ClaimService } from 'app/cd/services/claim-service';
import { apiCall } from 'app/shared/lib/api/api';
import { openProviderSummary } from 'app/cd/components/summary/provider/provider-summary';
import * as CD from 'app/cd/models/essette-api';


@autoinject()
export class ClaimInformation extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.stringNull({ defaultBindingMode: bindingMode.toView, changeHandler: 'reload' })
    public claimId: string | null = null;
    protected claim: CD.Claim | null = null;

    protected showProviderSummaryLink: boolean = false;
    protected openProviderSummary = openProviderSummary;


    ////****************** Element References ***************************************////



    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly claimService: ClaimService,
        ...rest: any[]) {

        super(...rest);
        this.logger.source = this;

        this.checkPermissions();
        this.reload(this.claimId)
    }


    ////****************** Events ***************************************************////
    public async reload(claimId: string | null): Promise<void> {
        if(claimId) {
            this.loadClaim(claimId);
        }
    }


    ////****************** Functions ************************************************////
    protected getProperty(code: string) {
        const property = [code];
        if(/lookup/i.test(code)) {
            property.push('description');
        }
        return property.join('.');
    }

    private async checkPermissions(): Promise<void> {
        await this.accountContext.load();
        this.showProviderSummaryLink = this.accountContext.hasRouteAccess('cd.provider.summary');
    }


    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadClaim(claimId: string): Promise<void> {
        const includes: string[] = [
            'placeOfService',
            'provider.primary',
            'provider.referring',
            'metadata.created.byUser',
            'metadata.modified.byUser',
            'provider.primary.location',
            'provider.referring.location',
            'custom.target.definitions'
        ];

        try {
            this.state.beginLoad();

            const response = await this.claimService.loadClaim(claimId, includes);
            this.claim = response.results[0];
        } catch(error) {
            throw error;
        } finally {
            this.state.endLoad();
        }
    }
}
